import { createRoot } from "react-dom/client";
import { AppErrorBoundary } from "../ui/AppErrorBoundary.tsx";
import { ensureWasmReadyWithNotification } from "../wasm/init.ts";
import { App } from "./App.tsx";

// Initialize WASM module before rendering — normals and mesh extraction
// depend on it being ready. The init is fast (~1ms) and cached.
// If WASM fails or stalls, render anyway so the toast system is available
// and the user gets a visible error instead of a blank screen.
ensureWasmReadyWithNotification()
  .catch(() => {
    // Error already surfaced via toast inside ensureWasmReadyWithNotification.
  })
  .finally(() => {
    createRoot(document.getElementById("root")!).render(
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>,
    );
  });
